import { render, staticRenderFns } from "./svg_icons.vue?vue&type=template&id=568284de"
import script from "./svg_icons.vue?vue&type=script&lang=js"
export * from "./svg_icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports